import { computed, Injectable, signal } from "@angular/core";
import { ShipmentStateModel } from "../Dto/ShipmentStateModel";
import { ShipmentEntity } from "../Dto/ShipmentModel";
import { PaginationInfo } from "../Dto/ShipmentSearchResponse";
import { ShipmentSearchRequest } from "../Dto/ShipmentSearchRequest";

const initialState: ShipmentStateModel = {
  data: [],
  pagination: { page: 1, limit: 10, total: 0, pages: 0 },
  searchParams: { page: 1, limit: 10 },
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class ShipmentState {
  private readonly state = signal<ShipmentStateModel>(initialState);

  readonly data = computed(() => this.state().data);
  readonly pagination = computed(() => this.state().pagination);
  readonly searchParams = computed(() => this.state().searchParams);
  readonly loading = computed(() => this.state().loading);
  readonly error = computed(() => this.state().error);

  setShipments(data: ShipmentEntity[], pagination: PaginationInfo): void {
    this.state.update((state) => ({ ...state, data, pagination, loading: false, error: null }));
  }

  setSearchParams(params: ShipmentSearchRequest): void {
    this.state.update((state) => ({ ...state, searchParams: params }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }

  addShipment(entity: ShipmentEntity): void {
    this.state.update((state) => ({
      ...state,
      data: [entity, ...state.data],
      pagination: { ...state.pagination, total: state.pagination.total + 1 },
    }));
  }

  updateShipment(entity: ShipmentEntity): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.map((item) =>
        (() => {
          if (item.id === entity.id) {
            return entity;
          }
          return item;
        })(),
      ),
    }));
  }

  removeShipment(id: string): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.filter((item) => item.id !== id),
      pagination: {
        ...state.pagination,
        total: Math.max(0, state.pagination.total - 1),
      },
    }));
  }
}
